<template>
<div>
  <vHeader class="vHeader" :title="title" v-show="showHeader"/>

  <div class="body">
    <router-view class="router-view"></router-view>
  </div>
</div>
</template>

<script>
import vHeader from "@/components/header.vue"

export default {
  components: {
    vHeader
  },

  computed: {
    title() {
      if (this.$route.name == "sent_email") {
        return this.$route.params.type == "sign_up" ? "会社登録" : "ログイン"
      } else {
        return this.$route.meta.title
      }
    },

    showHeader() {
      return this.$route.meta.hasSelfHeader ? false : true
    }
  }
}
</script>

<style lang="scss" scoped>
.vHeader /deep/ .title {
  vertical-align: top;
  margin-left: auto;
  margin-right: 45.7%;
  margin-top: auto;
  margin-bottom: auto;
}

.body {
  height: 100%;
  overflow: hidden;
}

.router-view {
  display: inline;
  vertical-align: middle;
}
</style>